const localization = {
    cannot_delete_default_language: '{{languageTag}} está definido como seu idioma padrão e não pode ser excluído.',
    invalid_translation_structure: 'Esquemas de dados inválidos. Verifique sua entrada e tente novamente.',
};
export default localization;
